import { isServer } from "helpers/commonHelpers";
import _isEmpty from "lodash/isEmpty";
import format from "date-fns/format";

export const getIstTimestamp = (today: Date, hour: number, min: number) => {
  today.setHours(today.getHours() + hour);
  today.setMinutes(today.getMinutes() + min);
  return new Date(today.toISOString()).getTime();
};

const monthName = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getDateMonthAndYearObject = (milliseconds: number) => {
  const d1 = new Date(milliseconds),
    d = d1.getDate(),
    m = d1.getMonth(),
    y = d1.getFullYear();
  return {
    month: monthName[m],
    date: d,
    year: y,
  };
};

export const toWebFormat = (date: string): string => {
  if (_isEmpty(date)) return "";
  return format(new Date(date), "dd/MM/yyyy");
};

export const getValidDateInput = (inputDate: string) => {
  let [date, month, year] = inputDate?.split("/");
  return `${month}/${date}/${year}`;
};

export const returnUserReadableDate = (isoDate: string) => {
  let date = new Date(isoDate);
  return date;
};
